import React, { useCallback } from 'react';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Dot, FilterToggleRow } from '../common/list/FilterToggleGroup';

// 거래유형 - 다중선택(OR) 필터라 FilterToggleGroup(단일선택) 대신 ToggleButtonGroup을
// 비배타(exclusive 없음) 모드로 직접 쓴다. 점+라벨 스타일만 FilterToggleGroup과 맞춤
// (2026-10-22, chancemng 설계 적용).
const tradeTypes = [
  { id: 1, value: '매출처', label: '매출처', color: 'primary' },
  { id: 2, value: '매입처', label: '매입처', color: 'secondary' },
  { id: 3, value: '제조사', label: '제조사', color: 'info' },
];

const PartnerStatusBox = ({ filters, onFilters }) => {
  const selected = Array.isArray(filters.searchTradeTyp) ? filters.searchTradeTyp : [];

  const handleChange = useCallback(
    (_event, next) => {
      onFilters('searchTradeTyp', next);
    },
    [onFilters],
  );

  return (
    <FilterToggleRow>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, flexShrink: 0, whiteSpace: 'nowrap' }}>
        거래유형
      </Typography>
      <ToggleButtonGroup
        size="small"
        value={selected}
        onChange={handleChange}
        sx={{
          flexWrap: 'nowrap',
          '& .MuiToggleButton-root': { textTransform: 'none', px: 1.1, py: 0.4, lineHeight: 1.4, whiteSpace: 'nowrap' },
        }}
      >
        {tradeTypes.map(({ id, value, label, color }) => (
          <ToggleButton key={id} value={value} aria-label={`${label} 필터 토글`}>
            <Dot color={color} />
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FilterToggleRow>
  );
};

export default PartnerStatusBox;
